module.exports = __webpack_public_path__ + "static/img/no_doctor.6642fa6d.png";